import api from "../hooks/api";
import { API_URLS } from "../App";
import { CampaignHistory } from "../model/Campaign";

/** Admin-only: campaign activation price history. */
export async function fetchCampaignHistory(
  campaignId: string,
): Promise<CampaignHistory> {
  const response = await api.get(`${API_URLS.CAMPAIGNS}/${campaignId}/history`);
  return response.data as CampaignHistory;
}
